// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      incidentThemeOptions: [
        "Electricty",
        "Working at Heights",
        "Ground",
        "Spill",
        "Gas",
        "Sharp Objects",
        "Pressure",
        "Loss of Control",
        "Other"
      ],
      // eslint-disable-next-line
      incidentTypeOptions: [
        "Major",
        "Minor",
        "Near Miss"
      ],
      // eslint-disable-next-line
      incidentConditionOptions: [
        "Operations",
        "Maintenance",
        "Isolation",
        "Project",
        "Start up",
        "Shutdown"
      ],
      // eslint-disable-next-line
      incidentInvestigationMethodsOptions: [
        "Evidence",
        "RCM",
        "RCA",
        "Fault Tree"
      ],
      // eslint-disable-next-line
      incidentInvestigationResultOptions: [
        "Complex",
        "Procedure",
        "Faulty Machine",
        "Human Factors"
      ]
    };
  }
};
